// Users stay on the V1 account (this factory is wired to the V1 client in
// api/ltng/index.js). Original V1 path, restored from the pre-cutover code —
// the V2 account's `1800-victims-users` module is empty and unverified.
export default function (axios) {
  return {
    getUsers(params) {
      return axios.get('/modules/users', params)
    },

    postUsers(data, params) {
      return axios.post('/modules/users', data, params)
    },

    putUsers(id, data, params) {
      return axios.put(`/modules/users/${id}`, data, params)
    },
  }
}
